import Error from '../model/Error';
import axios from 'axios';

export default class ClubHintRepository {
    static getCount(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`club/clubs/${clubId}/hints/count`)
                .then((response) => resolve(response.data.data.count))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getNew(clubId, uuids) {
        return new Promise((resolve, reject) => {
            axios
                .get(`club/clubs/${clubId}/hints/new-ones`, { params: uuids?.length ? { uuids } : {} })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getCategories(clubId, section) {
        return new Promise((resolve, reject) => {
            axios
                .get(`club/clubs/${clubId}/hints/categories`, { params: { section } })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static getProblems(clubId, section, category, page) {
        return new Promise((resolve, reject) => {
            axios
                .get(`club/clubs/${clubId}/hints`, { params: { section, category, page } })
                .then((response) => resolve({
                    problems: response.data.data,
                    pagination: response.data.meta.pagination,
                }))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static solveProblem(problemId, solution) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`club/clubs/hint/${problemId}/solve`, { solution })
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static updateProblem(problemId) {
        return new Promise((resolve, reject) => {
            axios
                .patch(`club/clubs/hint/${problemId}/update`, {})
                .then((response) => resolve(response.data.data))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
